import SearchIcon from '@ixigo/icons/Search';
import Input, { type InputProps } from '@ixigo/iui/Input';
import cn from '../../utils/cn';

export function Search({ classes, ...props }: InputProps) {
	return (
		<Input
			variant="outlined"
			endAdornment={<SearchIcon />}
			{...props}
			placeholder="Search for a location"
			classes={{
				...classes,
				outline: cn(
					'rounded-l-full rounded-r-full border-secondary',
					classes?.outline,
				),
			}}
		/>
	);
}
